import { Button, ConfigProvider, Form, Input } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import m3_logo from "../assets/images/M3_Logo.svg";
import GradientButton from "../Components/Button/GradientButton";
import otpVerification from "../Components/AllModal/otpVerificationForSignUp";
import toastMessage from "../utils/toastMessage";
import LoadingModal from "../Components/AllModal/LoadingModal";

function OtpForgotPassword({
  confirmEmail = false,
  confirmEmailMsg = "",
  href = "",
}) {
  const Navigate = useNavigate();
  // const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [otpInputs, setOtpInputs] = useState(["", "", "", "", "", ""]);
  // console.log("🚀 ~ otpInputs:", otpInputs.length)
  const otpInputRefs = useRef([
    React.createRef(),
    React.createRef(),
    React.createRef(),
    React.createRef(),
    React.createRef(),
    React.createRef(),
  ]);
  console.log("🚀 ~ otpInputRefs:", otpInputRefs);

  const handleOtpInputChange = (value, index, event) => {
    const updatedInputs = [...otpInputs];
    updatedInputs[index] = value;
    setOtpInputs(updatedInputs);

    // Check for backspace or delete on an empty field and move focus backward
    if (
      !value &&
      index > 0 &&
      (event.key === "Backspace" || event.key === "Delete")
    ) {
      otpInputRefs.current[index - 1].current.focus();
    }
    // Automatically focus on the next input if a number is entered
    else if (value && index < otpInputs.length - 1) {
      otpInputRefs.current[index + 1].current.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    // If backspace is pressed and the current field is empty, focus on the previous field
    if (e.key === "Backspace" && !otpInputs[index] && index > 0) {
      e.preventDefault(); // Prevent the default backspace behavior
      otpInputRefs.current[index - 1].current.focus();
    }
  };

  const handleOtpDone = () => {
    const otp = otpInputs.join("");
    const username = localStorage?.getItem("username");
    // const username = location.state.email;
    setLoading(true);
    // console.log(username, " = username, and otp = ", otp);
    if (confirmEmail) {
      otpVerification(username, otp, (err, msg) => {
        setLoading(false);
        if (err) {
          toastMessage(err, "error");
        } else {
          toastMessage(msg, "success");
          Navigate(href);
        }
      });
    } else {
      Navigate("/reset-password", { state: { otp, username } });
    }
  };

  const handlePaste = (e) => {
    e.preventDefault(); // Prevent the default paste behavior

    // Get the pasted content
    const pasteData = e.clipboardData.getData("text");

    // Extract digits and limit to the number of OTP fields
    const digits = pasteData.slice(0, otpInputs.length).split("");

    // Check if all are digits and length is equal to otpInputs length
    if (
      digits.length === otpInputs.length &&
      digits.every((digit) => /^\d$/.test(digit))
    ) {
      // Update the state with the pasted digits
      setOtpInputs(digits);

      // Automatically focus the last input field after pasting
      otpInputRefs.current[digits.length - 1].current.focus();
    } else {
      // Handle invalid paste content, e.g., not enough digits or contains non-numeric characters
      console.log("Invalid OTP paste content");
    }
  };

  // useEffect(() => {
  //   if (otpInputs.join("").length === 6) {
  //     setLoading(true);
  //     handleOtpDone(otpInputs.join(""));
  //   }
  // }, [otpInputs]);

  const handleKeyPress = (e) => {
    const regex = /^[0-9]*$/;
    const isValid = regex.test(e.key);
    if (!isValid) {
      e.preventDefault();
    }
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Input: {
            colorBgContainer: "transparent",
            colorIcon: "white",
            colorIconHover: "white",
            colorTextPlaceholder: "#DADADA",
            colorText: "white",
          },
          Form: {
            colorTextHeading: "white",
          },
        },
      }}
    >
      {loading && <LoadingModal className="bg-gray-500/80" />}
      <div className="bg-darkJungleGreen h-screen flex justify-center items-center text-white">
        <div className="m3_logo_register absolute top-10 left-16">
          <img src={m3_logo} />
        </div>
        <div className="bg-black shadow-signupBoxShadow px-10 py-28 rounded-2xl space-y-5 w-[494px]">
          {confirmEmail && (
            <p className="px-4 border-2 border-gray-200 py-1 rounded-lg text-center">
              Your Email is not verified, An OTP has been send to your email
              please verify your email
            </p>
          )}
          <h1 className="font-bold bg-signupTextBg inline-block text-transparent bg-clip-text text-2xl">
            Enter OTP
          </h1>
          <p>Enter OTP code you received .</p>
          <Form
            className=" text-black"
            name="basic"
            labelCol={{
              span: 24,
            }}
            wrapperCol={{
              span: 24,
            }}
            // initialValues={{ remember: true }}
            onFinish={handleOtpDone}
            // onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <div className="text-center space-x-5">
              {otpInputs?.map((inputValue, index) => (
                <Input
                  key={index}
                  size="large"
                  style={{ width: 50, height: 50, textAlign: "center" }}
                  autoFocus={index === 0}
                  value={inputValue}
                  maxLength={1}
                  onChange={(e) =>
                    handleOtpInputChange(e.target.value, index, e)
                  }
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  onPaste={handlePaste}
                  ref={otpInputRefs.current[index]}
                />
              ))}
            </div>

            <Form.Item className="mb-0">
              <GradientButton
                disabled={
                  !otpInputs.every(
                    (input) => input && input.trim().length === 1
                  )
                }
                // onClick={confirmEmail ? () => Navigate(href) : () => Navigate("/reset-password")}
                // onClick={handleOtpDone}
                className="bg-signupSubmitBtn w-full rounded-3xl mt-10"
                // type="primary"
                type="submit"
              >
                Submit
              </GradientButton>
            </Form.Item>
          </Form>
          <p>
            Haven't received OTP ?
            <span
              onClick={() => Navigate("/")}
              className="cursor-pointer bg-sandAgainBtn inline-block text-transparent bg-clip-text"
            >
              Send Again
            </span>
          </p>
        </div>
      </div>
    </ConfigProvider>
  );
}

export default OtpForgotPassword;
